import script from "./SortIcon.vue?vue&type=script&lang=jsx"
export * from "./SortIcon.vue?vue&type=script&lang=jsx"

import "./SortIcon.vue?vue&type=style&index=0&id=63e456c1&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63e456c1"]])

export default __exports__